import { runtimeStageAssetIdBySceneId } from "./assets";
import type { Scene } from "./schema";

export { modules } from "./moduleCatalog";

export const scenes = [
  {
    id: "M1S1",
    globalOrder: 1,
    moduleId: "M1",
    moduleOrder: 1,
    title: "抗日战争全面爆发和第二次国共合作正式形成",
    identity: "抗战史料研学员",
    timeLabel: "1937年7月7日—9月23日；军队改编档案延伸至10月",
    mainVenue: "北平宛平城·卢沟桥",
    archiveSlices: ["延安", "南京", "陕甘宁边区", "广西桂林"],
    taskIds: ["T01"],
    contentBlockIds: [
      "M1S1_LECTURE",
      "M1S1_C03",
      "GX01_ORIGINAL",
      "GX01_C04_01",
      "GX01_C04_02",
      "GX01_C04_03",
      "GX01_C04_04",
    ],
    assetIds: [
      "AST-M1S1-PROC-001",
      "AST-M1S1-PROC-002",
      "AST-M1S1-PROC-003",
      "AST-M1S1-PROC-004",
      "AST-M1S1-PROC-005",
      "AST-M1S1-PROC-006",
    ],
    reviewState: "pending_review",
    availability: "flagship",
  },
  {
    id: "M1S2",
    globalOrder: 2,
    moduleId: "M1",
    moduleOrder: 2,
    title: "党的全面抗战路线和持久战的战略总方针",
    identity: "抗战史料研学员",
    timeLabel: "1937年8月；1938年5—6月（两个历史节点）",
    mainVenue: "陕北洛川城郊、延安《论持久战》讲演场景",
    archiveSlices: [],
    taskIds: ["T02", "T03", "T04"],
    contentBlockIds: [],
    assetIds: ["AST-M1S2-CONFERENCE-TABLE", "AST-M1S2-MAP-TABLE", "AST-M1S2-DOCUMENT-WALL"],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M2S1",
    globalOrder: 3,
    moduleId: "M2",
    moduleOrder: 1,
    title: "八路军开赴抗日前线",
    identity: "抗战史料研学员",
    timeLabel: "主场景1937年9月25日；南京背景档案自12月13日起六周",
    mainVenue: "山西灵丘平型关一带",
    archiveSlices: ["南京庄重史料见证切片"],
    taskIds: ["T05"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M2S1],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M2S2",
    globalOrder: 4,
    moduleId: "M2",
    moduleOrder: 2,
    title: "敌后战场的开辟和敌后抗日根据地的创建",
    identity: "抗战史料研学员",
    timeLabel: "1937年11月—1938年4月",
    mainVenue: "晋察冀边区",
    archiveSlices: ["山西山区、河北和山东平原", "华中新四军活动区域"],
    taskIds: ["T06"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M2S2],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M2S3",
    globalOrder: 5,
    moduleId: "M2",
    moduleOrder: 3,
    title: "坚持统一战线中的独立自主",
    identity: "抗战史料研学员",
    timeLabel: "1937年11月底；1938年9—11月",
    mainVenue: "延安六届六中全会场景及相关文件档案空间",
    archiveSlices: [],
    taskIds: ["T07"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M2S3],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M3S1",
    globalOrder: 6,
    moduleId: "M3",
    moduleOrder: 1,
    title: "战略相持阶段到来后的局势和党的方针",
    identity: "抗战史料研学员",
    timeLabel: "1938年10月—1939年7月7日",
    mainVenue: "武汉、广州、延安等关键节点构成的全国抗战局势场景",
    archiveSlices: [],
    taskIds: ["T08"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M3S1],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M3S2",
    globalOrder: 7,
    moduleId: "M3",
    moduleOrder: 2,
    title: "敌后游击战争的发展和百团大战",
    identity: "抗战史料研学员",
    timeLabel: "1939年—1945年初；重点为1940年8月—1941年1月",
    mainVenue: "华北敌后战场及主要铁路、公路交通线",
    archiveSlices: [
      "1939年11月·钦廉、邕宁八尺区与中越边境",
      "1944年夏—9月·临桂—阳朔",
      "1945年初·桂东南与钦廉四属",
    ],
    taskIds: ["T09"],
    contentBlockIds: ["GX05_C07"],
    assetIds: [runtimeStageAssetIdBySceneId.M3S2],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M3S3",
    globalOrder: 8,
    moduleId: "M3",
    moduleOrder: 3,
    title: "沦陷区人民的抗日斗争",
    identity: "抗战史料研学员",
    timeLabel: "1937—1945年，重点为1940年下半年—1942年中",
    mainVenue: "中国各沦陷区",
    archiveSlices: ["香港—东江秘密营救路线"],
    taskIds: [],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M3S3],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M3S4",
    globalOrder: 9,
    moduleId: "M3",
    moduleOrder: 4,
    title: "打退和制止国民党顽固派的反共高潮",
    identity: "抗战史料研学员",
    timeLabel: "1939年冬—1943年，重点为1941年1—3月",
    mainVenue: "陕甘宁边区、华北、皖南和重庆",
    archiveSlices: ["皖南事变与政治舆论反击"],
    taskIds: ["T10"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M3S4],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M4S1",
    globalOrder: 10,
    moduleId: "M4",
    moduleOrder: 1,
    title: "敌后军民艰苦的反“扫荡”、反“清乡”斗争",
    identity: "抗战史料研学员",
    timeLabel: "1941年1月—1943年3月",
    mainVenue: "华北、华中敌后根据地",
    archiveSlices: ["潘家峪", "狼牙山", "刘老庄"],
    taskIds: ["T11", "T12"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M4S1],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M4S2",
    globalOrder: 11,
    moduleId: "M4",
    moduleOrder: 2,
    title: "大生产运动和抗日根据地的建设",
    identity: "抗战史料研学员",
    timeLabel: "1939年2月—1944年9月",
    mainVenue: "陕甘宁边区，以南泥湾、延安及根据地治理沙盘为主要场域",
    archiveSlices: [],
    taskIds: ["T13"],
    contentBlockIds: ["M4S2_C05"],
    assetIds: [runtimeStageAssetIdBySceneId.M4S2],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M4S3",
    globalOrder: 12,
    moduleId: "M4",
    moduleOrder: 3,
    title: "国民党统治区的抗日民主运动",
    identity: "抗战史料研学员",
    timeLabel: "主线1943年—1944年10月；广西节点1938年10月后—1944年冬",
    mainVenue: "重庆及豫湘桂战场",
    archiveSlices: ["1938年11月—1941年1月·桂林八路军办事处", "桂林", "昭平县黄姚"],
    taskIds: ["T14"],
    contentBlockIds: ["GX05_C08", "GX02_C06"],
    assetIds: [runtimeStageAssetIdBySceneId.M4S3],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M5S1",
    globalOrder: 13,
    moduleId: "M5",
    moduleOrder: 1,
    title: "党的建设“伟大的工程”",
    identity: "抗战史料研学员",
    timeLabel: "1938年底—1939年10月",
    mainVenue: "延安中共中央驻地",
    archiveSlices: ["全国党员发展与党建文献档案"],
    taskIds: ["T15"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M5S1],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M5S2",
    globalOrder: 14,
    moduleId: "M5",
    moduleOrder: 2,
    title: "系统阐明新民主主义理论",
    identity: "抗战史料研学员",
    timeLabel: "1939年末—1940年初",
    mainVenue: "延安理论文献研读场景（不虚构具体写作房间）",
    archiveSlices: [],
    taskIds: [],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M5S2],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M5S3",
    globalOrder: 15,
    moduleId: "M5",
    moduleOrder: 3,
    title: "整风运动和《关于若干历史问题的决议》",
    identity: "抗战史料研学员",
    timeLabel: "1941年5月—1945年4月",
    mainVenue: "延安及各抗日根据地",
    archiveSlices: [],
    taskIds: ["T16", "T17"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M5S3],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M6S1",
    globalOrder: 16,
    moduleId: "M6",
    moduleOrder: 1,
    title: "党的七大",
    identity: "抗战史料研学员",
    timeLabel: "1945年4—6月·中共七大召开期间",
    mainVenue: "延安杨家岭中央大礼堂",
    archiveSlices: ["七大报告", "政治路线", "三大作风档案"],
    taskIds: ["T18"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M6S1],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M6S2",
    globalOrder: 17,
    moduleId: "M6",
    moduleOrder: 2,
    title: "确立毛泽东思想为党的指导思想",
    identity: "抗战史料研学员",
    timeLabel: "1945年4—6月·七大审议并通过党章阶段",
    mainVenue: "延安杨家岭中央大礼堂",
    archiveSlices: ["《关于修改党章的报告》", "七大党章档案"],
    taskIds: [],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M6S2],
    reviewState: "pending_review",
    availability: "structured",
  },
  {
    id: "M6S3",
    globalOrder: 18,
    moduleId: "M6",
    moduleOrder: 3,
    title: "全面反攻与抗日战争的伟大胜利",
    identity: "抗战史料研学员",
    timeLabel: "1945年上半年—10月25日，重点8月9日、8月15日、9月2日、9月3日、10月25日",
    mainVenue: "延安总部、中国东北、东京湾和台湾台北",
    archiveSlices: [],
    taskIds: ["T19"],
    contentBlockIds: [],
    assetIds: [runtimeStageAssetIdBySceneId.M6S3],
    reviewState: "pending_review",
    availability: "structured",
  },
] satisfies Scene[];
